<div
  [ngClass]="{
    'bg-red-50  border-red-200': isMissing,
    'bg-blue-50 border-blue-200': !isMissing,
  }"
  class="rounded-lg p-6 shadow-sm border"
>
  <div class="flex mb-4">
    <div class="flex flex-col" *ngIf="question.index_number">
      <div
        class="font-bold rounded-full w-8 h-8 flex items-center justify-center mr-3"
        [ngClass]="{
          'bg-red-100 border-red-200': isMissing,
          'bg-blue-100 text-blue-700': !isMissing,
        }"
      >
        {{ question.index_number }}
      </div>
    </div>
    <h2 class="text-lg font-semibold">
      <span [innerHTML]="questionHtml | safeHtml"></span>
    </h2>
  </div>
  <div class="space-y-4 px-10">
    <div class="quiz-option flex items-start" *ngFor="let answer of question.answers">
      <div class="relative flex items-start justify-start">
        <input
          type="radio"
          type="radio"
          [name]="'question_' + question.uuid"
          [value]="answer.uuid"
          [id]="'answer_' + answer.uuid"
          [required]="question.is_required"
          (change)="handleSelection(answer.uuid)"
          class="appearance-none h-5 w-5 border-2 border-blue-300 rounded-full checked:bg-blue-500 checked:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all cursor-pointer"
        />
      </div>
      <label [for]="'answer_' + answer.uuid" class="ml-3 cursor-pointer select-none">{{
        answer.answer
      }}</label>
    </div>
  </div>
  <div class="mt-6 pt-4 border-dashed border-t border-blue-200" *ngIf="question.is_confidence">
    <p class="mb-3 font-medium">
      Please select the extent to which you feel confident in your answer:
      <span *ngIf="question.is_required" class="text-red-500"> *</span>
    </p>

    <div class="grid grid-cols-5 gap-0 mt-2">
      <div class="flex flex-col items-center">
        <label
          for="q1_conf-5_{{ question.uuid }}"
          class="likert-option flex flex-col items-center cursor-pointer"
        >
          <div class="relative flex items-center justify-center mb-1">
            <input
              type="radio"
              id="q1_conf-5_{{ question.uuid }}"
              name="q1_conf_{{ question.uuid }}"
              (change)="handleConfidenceChange('Completely Confident')"
              value="Completely Confident"
              class="appearance-none h-5 w-5 border-2 border-blue-300 rounded-full checked:bg-blue-500 checked:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all cursor-pointer"
            />
          </div>
          <span class="text-[11px] md:text-[12px] lg:text-[14px] text-center font-semibold"
            >Completely Confident</span
          >
        </label>
      </div>

      <!-- Fairly Confident -->
      <div class="flex flex-col items-center">
        <label
          for="q1_conf-4_{{ question.uuid }}"
          class="likert-option flex flex-col items-center cursor-pointer"
        >
          <div class="relative flex items-center justify-center mb-1">
            <input
              type="radio"
              id="q1_conf-4_{{ question.uuid }}"
              name="q1_conf_{{ question.uuid }}"
              (change)="handleConfidenceChange('Fairly Confident')"
              value="Fairly Confident"
              class="appearance-none h-5 w-5 border-2 border-blue-300 rounded-full checked:bg-blue-500 checked:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all cursor-pointer"
            />
          </div>
          <span class="text-[11px] md:text-[12px] lg:text-[14px] text-center font-semibold"
            >Fairly Confident</span
          >
        </label>
      </div>

      <!-- Somewhat Confident -->
      <div class="flex flex-col items-center">
        <label
          for="q1_conf-3_{{ question.uuid }}"
          class="likert-option flex flex-col items-center cursor-pointer"
        >
          <div class="relative flex items-center justify-center mb-1">
            <input
              type="radio"
              id="q1_conf-3_{{ question.uuid }}"
              name="q1_conf_{{ question.uuid }}"
              (change)="handleConfidenceChange('Somewhat Confident')"
              value="Somewhat Confident"
              class="appearance-none h-5 w-5 border-2 border-blue-300 rounded-full checked:bg-blue-500 checked:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all cursor-pointer"
            />
          </div>
          <span class="text-[11px] md:text-[12px] lg:text-[14px] text-center font-semibold"
            >Somewhat Confident</span
          >
        </label>
      </div>

      <!-- Slightly Confident -->
      <div class="flex flex-col items-center">
        <label
          for="q1_conf-2_{{ question.uuid }}"
          class="likert-option flex flex-col items-center cursor-pointer"
        >
          <div class="relative flex items-center justify-center mb-1">
            <input
              type="radio"
              id="q1_conf-2_{{ question.uuid }}"
              name="q1_conf_{{ question.uuid }}"
              (change)="handleConfidenceChange('Slightly Confident')"
              value="Slightly Confident"
              class="appearance-none h-5 w-5 border-2 border-blue-300 rounded-full checked:bg-blue-500 checked:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all cursor-pointer"
            />
          </div>
          <span class="text-[11px] md:text-[12px] lg:text-[14px] text-center font-semibold"
            >Slightly Confident</span
          >
        </label>
      </div>

      <!-- Not Confident -->
      <div class="flex flex-col items-center">
        <label
          for="q1_conf-1_{{ question.uuid }}"
          class="likert-option flex flex-col items-center cursor-pointer"
        >
          <div class="relative flex items-center justify-center mb-1">
            <input
              type="radio"
              id="q1_conf-1_{{ question.uuid }}"
              name="q1_conf_{{ question.uuid }}"
              (change)="handleConfidenceChange('Not Confident')"
              value="Not Confident"
              class="appearance-none h-5 w-5 border-2 border-blue-300 rounded-full checked:bg-blue-500 checked:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all cursor-pointer"
            />
          </div>
          <span class="text-[11px] md:text-[12px] lg:text-[14px] text-center font-semibold"
            >Not Confident</span
          >
        </label>
      </div>
    </div>
  </div>
</div>
